import Carousel from 'assets/images/Carousel';
import Immutable from 'immutable';
import React from 'react';
import { useSelector } from 'react-redux';
import List from 'components/AssetList';
import Header from 'components/AssetList/Header';
import { useToggle } from 'components/AssetList/hooks';
import { IComponentItemOwnProps } from 'components/ComponentItem/models';
import { EntityType, ProjectsConfig, ScreenType } from 'const';
import { projectType as projectTypeSelector } from 'containers/Project/selectors';
import { activeScreenDefinition } from 'containers/ScreenDefinitions/selectors';
import { intlGet } from 'utils/intlGet';
import CarouselElement from './CarouselElement';

type InteractiveElement = EntityType.CAROUSEL_ELEMENT;

const Elements: InteractiveElement[] = [
  EntityType.CAROUSEL_ELEMENT,
];

const LayoutIconsByType: Record<InteractiveElement, React.FunctionComponent> = {
  [EntityType.CAROUSEL_ELEMENT]: Carousel,
};

const getComponent = (type: InteractiveElement): React.FunctionComponent<IComponentItemOwnProps> | null => {
  if (type === EntityType.CAROUSEL_ELEMENT) {
    return CarouselElement;
  }

  return null;
};

const InteractiveElements: React.FunctionComponent = () => {
  const dataTestId = 'projectPanel-listsContainer-elements-interactive-elementsList';
  const {
    expanded,
    toggle,
  } = useToggle({ isExpand: true });
  const projectType = useSelector(projectTypeSelector);
  const currentActiveScreenDefinition = useSelector(activeScreenDefinition);
  const { allowInteractiveElements } = ProjectsConfig[projectType];
  const screenType = currentActiveScreenDefinition.get('screenType');

  if (screenType !== ScreenType.KINETIC) {
    return null;
  }

  if (!allowInteractiveElements) {
    return null;
  }

  const renderElement = (type: InteractiveElement, index: number): JSX.Element | null => {
    const icon: React.FunctionComponent = LayoutIconsByType[type];
    const Component = getComponent(type);
    if (!Component) {
      return null;
    }

    return (
      <Component
        key={type}
        type={type}
        icon={icon}
        dataTestId={`${dataTestId}-list-item${index}`}
      />
    );
  };

  return (
    <div data-title="interactive-elements" data-testid={dataTestId}>
      <Header
        title={intlGet('Assets', 'Interactive Elements', { count: Elements.length })}
        expanded={expanded}
        onClick={toggle}
        dataTestId={`${dataTestId}-header`}
      />
      {
        expanded &&
        <List
          layout="grid"
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          elements={Immutable.List(Elements) as any}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          renderElement={(type: any, index: number): JSX.Element | null => renderElement(type, index)}
          dataTestId={`${dataTestId}-list`}
        />
      }
    </div>
  );
};

export default InteractiveElements;
